import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="mark-done"
export default class extends Controller {
  static targets = ["message", "button"];

  connect() {
    this.totalButtons = this.buttonTargets.length;
    this.completedCount = 0;
  }

  complete(event) {
    const button = event.currentTarget;
    const icon = button.querySelector(".icon");

    if (!button.classList.contains("cursor-default")) {
      this.completedCount++;
    }

    icon.classList.remove("fa-calendar-check", "fa-person-chalkboard");
    icon.classList.add("fa-check-circle", "text-white");

    button.classList.remove("hover:bg-emerald-600", "hover:bg-blue-600");
    button.classList.add("opacity-80", "cursor-default");

    if (this.completedCount === this.totalButtons) {
      this.messageTarget.classList.remove("hidden");
    }
  }
}
